import { styles } from "./styles";
import { FC } from "react";
import { Button, Form, FormProps, Input } from "antd";
import { Content } from "antd/es/layout/layout";
import { useControllers } from "@view/hooks/useControllers";
import { IScreenControllerLogin } from "@screens/LoginScreen/connector/__types__/UIViewController";
import withControllers from "@view/root/__proto__/withController";
import { ScreenControllerLogin } from "@screens/LoginScreen/connector/UIViewController";
import { observer } from "mobx-react";

type FieldType = {
  username: string;
  password: string;
};

const LoginScreen: FC = observer(() => {
  const { UIViewController } = useControllers<{
    UIViewController: IScreenControllerLogin;
  }>();

  const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
    await UIViewController.login(values);
  };

  const onFinishFailed: FormProps<FieldType>["onFinishFailed"] = (
    errorInfo
  ) => {
    // console.warn("Failed:", errorInfo);
  };

  return (
    <Content className={styles.content}>
      <img
        src="https://taker.io/wp-content/uploads/2018/11/Taker_logo_250.png"
        alt="taker logo"
        className={styles.logo}
      />
      <Form
        name="basic"
        layout="vertical"
        style={{ width: 400 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item<FieldType>
          label="Username"
          name="username"
          rules={[{ message: "Please input your username!", required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item<FieldType>
          label="Password"
          name="password"
          rules={[{ message: "Please input your password!", required: true }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 10, span: 18 }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={UIViewController.isRequestInProgress}
          >
            Login
          </Button>
        </Form.Item>
      </Form>
    </Content>
  );
});

export default withControllers(ScreenControllerLogin)(LoginScreen);
